import * as path from 'path';
import Image from 'next/image';
import {imageSet} from '../paths';
import useWindowDimensions from '../hooks/window-dimensions';
import {ShowContentInTabs} from '../widgets/show-content-in-tabs';
import {BlackTopCard} from '../widgets/black-top-card';
import {pathJoin} from '@helpers/common/string.mjs';
import React from 'react';

export function ImageViewer(props) {
  const {windowWidth} = useWindowDimensions();
  if (typeof window !== 'object') {
    console.log('no window');
    return <></>;
  }
  const isMobile = windowWidth < 480;
  // console.log({windowWidth})

  if (!props?.choices || !Object.values(props?.choices)?.length) {
    return <></>;
  }
  const prefix = '/wiring-diagrams';

  const width = isMobile ? 800 : 1101;
  const height = isMobile ? 883 : 1068;

  const ohmFolder = {
    1: 'Single 2 Ohm Wiring Diagrams',
    2: 'Single 4 Ohm Wiring Diagrams',
    3: 'Single 8 Ohm Wiring Diagrams',
    4: 'Dual 1 Ohm Wiring Diagrams',
    5: 'Dual 2 Ohm Wiring Diagrams',
    6: 'Dual 4 Ohm Wiring Diagrams'
  }[props.choices.ohmOption];

  const Dx = {
    1: 'S2',
    2: 'S4',
    3: 'S8',
    4: 'D1',
    5: 'D2',
    6: 'D4'
  }[props.choices.ohmOption];

  let count = props?.choices?.speakersCount;

  const subwoofers = `(${count}) ${Dx} Subwoofer${count > 1 ? 's' : ''}`;
  const deviceType = isMobile ? 'Mobile' : 'Desktop';
  let imageFolder = `/${ohmFolder}/${subwoofers}/${deviceType}/`;
  let options = imageSet.filter((ohm) =>
    ohm.includes(imageFolder + `Wiring Diagram - (${count}) ${Dx} - `)
  );
  // console.log('options', options.length);
  // console.log('windowWidth', windowWidth, 'isMobile', isMobile, 'deviceType', deviceType);
  const imagePaths = options?.filter((x) => x?.endsWith(`${deviceType}.jpg`));
  // console.log(imagePaths);

  if (!imagePaths?.length) {
    imagePaths.push('https://via.placeholder.com/1001');
  }
  const ohmList = imagePaths?.map((imagePath) => {
    const ohm = Number(path?.basename(imagePath)?.split('-')?.[2]?.trim()?.split(' ')?.[0]);
    return ohm;
  });

  return (
    <div className={'slideInDown'}>
      <BlackTopCard
        header={
          <>
            <strong>STEP 3</strong>: Choose Configuration
          </>
        }
        checked={true}>
        <ShowContentInTabs tabs={ohmList.map((x) => x + ' Ohm')}>
          {(tab) => {
            return (
              <OneImage
                imagePath={pathJoin(prefix, imagePaths[tab])}
                ohm={ohmList[tab]}
                width={width}
                height={height}
                alt="Image Viewer for Selected Product"
              />
            );
          }}
        </ShowContentInTabs>
      </BlackTopCard>
    </div>
  );
}

export function OneImage({imagePath, ohm, width, height}) {
  return (
    <div className="m-0 mt-0 p-0 mx-auto diagram-img" style={{pageBreakAfter: 'always'}}>
      <Image
        alt={`Wiring Diagram for ${ohm} Ohm`}
        src={imagePath}
        width={width}
        height={height}
        style={{margin: '0 auto', border: '1px solid silver'}}
      />

      {ohm < 1 && (
        <>
          <div className="pt-3" />
          <div className={'p-3 bg-yellow-300 text-black m-3'}>
            <strong>Warning</strong>: Wiring subwoofers to an amplifier at a final impedance load
            below 1-ohm is strongly discouraged. Most amplifiers are not designed to run at such a
            low impedance and Skar Audio's warranty policy explicitly states your warranty will be
            void if you operate it at such a load. This diagram is intended to be used for
            informational purposes only.
          </div>
        </>
      )}
    </div>
  );
}
